<template>
  <div class="notification-container">
    <Notification
        v-for="notification in notifications"
        :key="notification.id"
        :id="notification.id"
        :type="notification.type"
        :title="notification.title"
        :message="notification.message"
        :duration="notification.duration"
        @remove="removeNotification"
    />
  </div>
</template>

<script>
import Notification from "./Notification.vue";

export default {
  name: "NotificationContainer",
  components: { Notification },
  data() {
    return {
      notifications: [],
      nextId: 1,
    };
  },
  methods: {
    addNotification(type, title, message, duration = 4000) {
      this.notifications.push({
        id: this.nextId++,
        type,
        title,
        message,
        duration,
      });
    },
    removeNotification(id) {
      this.notifications = this.notifications.filter((n) => n.id !== id);
    },
  },
};
</script>

<style scoped>
.notification-container {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 999999;
  max-width: 300px;
}
</style>
